import * as React from 'reactn';
import {
    ComponentFactory, ComponentUtil,
    dialog,
    IBaseDialogProps
} from "oca-lib-web";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory
}

class CustomDateDialog extends React.Component<IBaseDialogProps, IState> {

    public componentRefs = ComponentUtil.createRefs(2);

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(this.global.dataManager, null, {});
        componentFactory.setHandleUpdateCallback((value:any, key:string) => {
        });

        this.state = {
            componentFactory:componentFactory
        };
        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    componentDidMount() {

    }

    async handleSave(callback:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        console.log(componentBinding.item);

        callback(componentBinding.item);
    }

    // Filter selection dialog
    public render() {
        let cf = this.state.componentFactory;
        return (
            cf.renderBox([
                cf.renderBoxPadded(cf.renderDateField("startDate", "Start Date", "date", this.componentRefs[0])),
                cf.renderBoxPadded(cf.renderDateField("endDate", "End Date", "date", this.componentRefs[1]))
            ])
        )
    }
}

export default dialog(CustomDateDialog)